// extracted by mini-css-extract-plugin
export default {"btop":"_8c1821506a a626fb4e20 _9b2ae8eaba","icon":"eb069cdd12 bc43d7efac","btoppink":"_9ef04bed69 _602320ee89"};